import React from "react";

function SellItem() {
  return (
    <div>
      <h2>Sell/Remove Item</h2>
      <p>Form to mark item as sold and add to transaction history.</p>
    </div>
  );
}

export default SellItem;
